<template>
    <v-dialog v-model="isShowDialog" persistent max-width="50rem">
        <v-card>
            <v-card-title class="secondary elevation-4 white--text">
                <div class="text-h5">
                    <v-icon class="pb-1" color="white" medium> mail </v-icon>
                    {{ $t(dialogMenu) }}
                </div>
            </v-card-title>
            <v-card-text class="pa-4">
                <v-form v-model="isValid" @submit.prevent>
                    <text-field-label
                        ref="email"
                        v-model="email"
                        :label="$t('Mail_Address')"
                        :rules="[rules.required, rules.email, rules.maxChars(email, 254)]"
                        type="text"
                        @keydown.13="sendMail"
                    />
                </v-form>
            </v-card-text>
            <v-card-actions>
                <v-spacer />
                <button-app-control :label="$t('Cancel')" :disabled="isSendMailProcessing" text @click="closeDialog" />
                <button-app-control
                    :label="$t('Send_Mail')"
                    :disabled="isSendMailDisabled || !isValid || isSendMailProcessing"
                    :loading="isSendMailProcessing"
                    @click="sendMail"
                />
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script lang="ts">
import { mixins } from 'vue-class-component';
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { Action } from 'vuex-class';
import { State } from 'vuex-class';
import InputValidation from '../../../mixins/InputValidation';
import type { AuthState } from '../../../store/modules/auth/types';
import { ButtonAppControl, TextFieldLabel } from '../../atoms';

@Component({
    name: 'TheSendMailDialog',
    components: {
        ButtonAppControl,
        TextFieldLabel,
    },
})
export default class TheSendMailDialog extends mixins(InputValidation) {
    @Prop({ default: false }) isShow: boolean;
    @Prop({ default: '' }) menuTitle: string;
    @State('auth') auth: AuthState;
    @Watch('isShowDialog')
    onIsShowDialogChanged(val: boolean, oldVal: boolean): void {
        if (val) {
            this.dataInit();
        }
    }

    email = '';

    /**
     * getter, setter
     */
    get isShowDialog(): boolean {
        return this.isShow;
    }
    set isShowDialog(newVal: boolean) {
        this.closeDialog();
    }
    get dialogMenu(): string {
        return this.menuTitle;
    }
    get isSendMailDisabled(): boolean {
        return !this.email;
    }
    get isSendMailProcessing(): boolean {
        return this.auth.sendMail.isProcessing;
    }

    /**
     * methods
     */
    dataInit(): void {
        const r = (this as any).$refs.email;
        if (r) {
            r.reset();
        }
        this.validationReset();
    }
    closeDialog(): void {
        this.$emit('cancel-dialog');
    }
    sendMail(): void {
        if (this.isValid && !this.isSendMailProcessing) {
            this.$emit('send-mail', this.email);
        }
    }
}
</script>
